import BaseRegulation from "../base_regulation";

export default class SHRegulation extends BaseRegulation {

}